import { render, staticRenderFns } from "./MsgConfig.vue?vue&type=template&id=f6d89bbe"
import script from "./MsgConfig.vue?vue&type=script&lang=js"
export * from "./MsgConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports